import { Component, OnInit } from '@angular/core';

import { IBitfMenuItem } from '@interfaces';
import { bitfToTranslate } from '@common/libs/bitforce/utils/bitf-translate.utils';
import { APP_VERSION, BUILD_DATE } from '@env/version';
import { UiRoleManagerService } from '@web/core/services';
import { ERoleActions } from '@web/enums';

@Component({
  selector: 'prada-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
})
export class MainMenuComponent implements OnInit {
  isOpen = false;

  appVersion = APP_VERSION;
  appBuildAt = BUILD_DATE;

  menuItems: Array<IBitfMenuItem> = [];

  constructor(private uiRoleManagerService: UiRoleManagerService) {
    if (this.uiRoleManagerService.canI(ERoleActions.VIEW_HOME)) {
      this.menuItems.push({
        icon: 'home',
        label: bitfToTranslate('COMMON.LABEL.HOME'),
        url: '/',
      });
    }
    if (this.uiRoleManagerService.canI(ERoleActions.VIEW_DOCUMENT_ARCHIVE)) {
      this.menuItems.push({
        icon: 'archive',
        label: bitfToTranslate('COMMON.LABEL.DOCUMENTS'),
        url: '/documents',
      });
    }
    if (this.uiRoleManagerService.canI(ERoleActions.VIEW_SETTINGS)) {
      this.menuItems.push({
        icon: 'settings',
        label: bitfToTranslate('COMMON.LABEL.SETTINGS'),
        url: '/settings',
      });
    }
  }

  ngOnInit() {}
}
